import { BlocksContent } from "@strapi/blocks-react-renderer";

export function blocksToString(content: BlocksContent): string {
  let text = "";

  content.forEach((block) => {
    block.children.forEach((child) => {
      if (child.type === "text") {
        text += child.text;
      }
      // Handle other child types like links or images as needed
    });
    text += "\n"; // Add a newline between blocks
  });

  return text;
}

export function limitTextBlock(str: string, length: number) {
  if (str.length < length) return str;

  let _str = "";
  str.split("").forEach((word) => {
    if ((_str + word).length <= length) {
      _str += word;
    }
  });

  return _str + "...";
}
